import i18n from 'modules/core/lib/i18n'

import { InsightCard } from 'modules/project_management/components/InsightCard'
import PlanningStackedBar from 'modules/project_management/components/PlanningStackedBar'
import { budgetTypesEnum } from 'modules/project_management/lib/constants'

interface FixedTimeBudgetCounterProps {
  imputedMinutes: number
  fixedTimeBudget: number
  locale: string
}

const FixedTimeBudgetCounter = ({
  imputedMinutes,
  fixedTimeBudget,
  locale,
}: FixedTimeBudgetCounterProps) => {
  return (
    <InsightCard
      title={i18n.t('project_management.details.total_hours')}
      titleGap="s0"
      showOverageTag={fixedTimeBudget < imputedMinutes}
    >
      <PlanningStackedBar
        planningSelected={budgetTypesEnum.fixedTimeBudget}
        allocated={imputedMinutes}
        planned={fixedTimeBudget}
        currency={''}
        locale={locale}
      />
    </InsightCard>
  )
}

export default FixedTimeBudgetCounter
